/**
 * Created by Marcus Zhao on 12/10/2020
 * Description:
 * ---------maintenance history-------------
 * Updated by Daniel Wang on 12/30/2022, To implement the contact template draggable.
 */

import { Component, OnInit } from '@angular/core';
import { TemplateSettingDialogService } from './template-setting-dialog.service';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { ContactService } from '../../tamalelibs/services/contact.service';
import * as _lodash from 'lodash';
import { DefaultConfigurationContactTemplate } from '../../tamalelibs/constants/configurationContactTemplate.constants';
import { NotificationStyles, NotificationOptions } from '../../widgets/notification/notification.model';
import { AlertWindowService } from '../../widgets/alert-window/alert-window.service';
import { ToastService } from '../../widgets/toast/toast.service';
import { SettingConfig, rowFieldJson, ActionType, contactDefField } from './template-setting-dialog.model';
import { ControlId } from '../contact-dialog-new/contact-dialog.model';
import { OnDestroy } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { contactTemplateConfigSelector } from '../../tamalelibs/redux/contact.reducer';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../redux';
import { businessConstants } from '../../tamalelibs/constants/business.constants';
import { SAVE_CONTACT_TEMPLATE } from '../../tamalelibs/redux/contact.actions';
import { ContactDialogSectionName } from '../contact-detail-new/contact-body-detail.model';
import { StringLiteralsPipe } from '../../pipes/translate.pipe';

@Component({
    selector: 'tam-template-setting-dialog',
    templateUrl: './template-setting-dialog.component.html',
    styleUrls: ['./template-setting-dialog.component.scss']
})
export class TemplateSettingDialogComponent implements OnInit, OnDestroy {
    opened: boolean;
    tplConfig: any;

    private _isChangeConfig = false; // if changed need alert tip
    private _templateConfig: any;
    private _defaultConfig: any;
    private _destroySubscriptions: Array<Subscription> = [];
    private _sectionList: [];
    private _hasSuffix = false;
    private _hasPrefix = false;
    private _hasMiddle = false;
    private _infoToast: NotificationOptions = {
        message: '',
        style: NotificationStyles.Success
    };

    constructor(
        private _templateSettingService: TemplateSettingDialogService,
        private _contactService: ContactService,
        private _alertWindow: AlertWindowService,
        private _toast: ToastService,
        private _store: Store<AppState>,
    ) { }

    ngOnInit() {
        this._templateSettingService.dialogOpen$.pipe(
            filter(action => !this.opened),
        ).subscribe(() => {
            this._templateSettingService.actionSubject$ = new ReplaySubject<any>(6);
            this._destroySubscriptions.push(
                this._templateSettingService.actionSubject$.subscribe(item => this._settingTemplateConfig(item))
            );
            this.opened = true;
            this._initTemplate();
        });
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
        this._destroySubscriptions = [];
    }

    /**
     *cancel
     *
     * @memberof TemplateSettingDialogComponent
     */
    cancel() {
        this.clickClose(null);
    }

    /**
     * close
     *
     * @param {*} event
     * @memberof TemplateSettingDialogComponent
     */
    clickClose(event) {
        if (this._isChangeConfig) {
            const subscription = this._alertWindow.warn(StringLiteralsPipe.translate('general.you_have_unsaved'), [], StringLiteralsPipe.translate('general.discard'), StringLiteralsPipe.translate('general.go_back'), '', '').subscribe((result: boolean) => {
                if (result) {
                    this.opened = false;
                    this._clearData();
                }
                subscription.unsubscribe();
            });
        } else {
            this.opened = false;
            this._clearData();
        }
    }

    /**
     * reset Template
     *
     * @param {*} event
     * @memberof TemplateSettingDialogComponent
     */
    clickResetDefault(event) {
        const subscription = this._alertWindow.warn(StringLiteralsPipe.translate('general.reset_to_default_template'), [], StringLiteralsPipe.translate('general.reset'), StringLiteralsPipe.translate('general.go_back'), '', '').subscribe((result: boolean) => {
            if (result) {
                this._templateConfig = _lodash.cloneDeep(this._defaultConfig);
                this.tplConfig = this._templateConfig.contains;
                this._templateSettingService.actionSubject$.next(new SettingConfig(ActionType.RESET, '', this.tplConfig[0].sectionName));
            }
            subscription.unsubscribe();
        });
    }

    /**
     * save Template
     *
     * @memberof TemplateSettingDialogComponent
     */
    saveTemplate() {
        // get the company config in basic information
        let sourceInfo = null;
        for (let i = 0; i < this._templateConfig.contains.length; i++) {
            const item = this._templateConfig.contains[i];
            if (item.sectionName === ContactDialogSectionName.BasicInformation) {
                item.container.map(array => {
                    array.map(_item => {
                        if (_item.config.controlID === ControlId.Company) {
                            sourceInfo = _item.config['source'];
                        }
                    });
                });
                break;
            }
        }
        // set value for the company config in former employment
        for (let i = 0; i < this._templateConfig.contains.length; i++) {
            const item = this._templateConfig.contains[i];
            if (item.sectionName === ContactDialogSectionName.Employment) {
                item.container.map(array => {
                    array.map(_item => {
                        if (_item.config.controlID === ControlId.EmploymentCompany) {
                            _item.config['source'] = sourceInfo;
                        }
                    });
                });
                break;
            }
        }

        this._destroySubscriptions.push(
            this._contactService.setContactTemplate(businessConstants.Contacts.Contact_Template_Id, this._templateConfig)
                .subscribe(res => this._uploadData(res)));
    }

    /**
    * add new field to layout
    *
    * @private
    * @param {*} config
    * @param {SettingConfig} item
    * @memberof TemplateSettingDialogComponent
    */
    private _addFieldtoLayoutConfig(config, item: SettingConfig) {
        const ctrlName = item.data.name;
        const _rowFieldJson = _lodash.cloneDeep(rowFieldJson);
        _rowFieldJson.config.controlName = ctrlName;
        _rowFieldJson.config.controlID = ctrlName;
        _rowFieldJson.config.controlType = item.data.type;
        // get basic information container
        const basicInfoSection = this._getBasicInformationByContainer(config);

        if (ctrlName === contactDefField.Birthday || ctrlName === contactDefField.Gender) {
            const sectionInfo = config.filter(data => data.sectionName === item.location.toUpperCase());
            sectionInfo[0].container.push(new Array(_rowFieldJson));
        } else if (ctrlName === contactDefField.MiddleName) {
            _rowFieldJson.css.width = '616';
            let _rowIndex = -1;
            basicInfoSection.container.splice(1, 0, new Array(_rowFieldJson));
            basicInfoSection.container.forEach((row, rowIndex) => {
                row.forEach((column, columnIndex) => {
                    if (column.config.controlID === ControlId.LastName) {
                        if (rowIndex === 0) {
                            _rowIndex = rowIndex;
                            basicInfoSection.container[0][0].css.width = '616';
                            basicInfoSection.container[0][1].css.width = '616';
                            basicInfoSection.container.splice(2, 0, new Array(basicInfoSection.container[0][1]));
                            basicInfoSection.container[0].splice(1, 1);
                        }
                    }
                });
            });
        } else if (ctrlName === contactDefField.Prefix) {
            _rowFieldJson.css.width = '152';
            basicInfoSection.container[0].splice(0, 0, _rowFieldJson);
            basicInfoSection.container[0][1].css.width = '456';
            if (basicInfoSection.container[0].length > 2) {
                basicInfoSection.container[0][2].css.width = '616';
                basicInfoSection.container.splice(1, 0, new Array(basicInfoSection.container[0][2]));
                basicInfoSection.container[0].splice(2, 1);
            }
        } else if (ctrlName === contactDefField.Suffix) {
            _rowFieldJson.css.width = '152';
            let _columnIndex;
            let _rowIndex;
            basicInfoSection.container.forEach((row, rowIndex) => {
                row.forEach((column, columnIndex) => {
                    if (column.config.controlID === ControlId.LastName) {
                        _rowIndex = rowIndex;
                        _columnIndex = columnIndex;
                    }
                });
            });
            if (_rowIndex === 0) {
                basicInfoSection.container[0][0].css.width = '616';
                basicInfoSection.container[0][1].css.width = '456';
                const lastName = basicInfoSection.container[0][1];
                basicInfoSection.container.splice(1, 0, new Array(lastName));
                basicInfoSection.container[1].splice(1, 0, _rowFieldJson);
                basicInfoSection.container[0].splice(1, 1);
            } else if (_rowIndex === 1 || _rowIndex === 2) {
                basicInfoSection.container[_rowIndex][0].css.width = '456';
                basicInfoSection.container[_rowIndex].splice(1, 0, _rowFieldJson);
            }
        }
    }

    /**
     * @private
     * @memberof TemplateSettingDialogComponent
     */
    private _clearData() {
        this.tplConfig = null;
        this._isChangeConfig = false; // if changed need alert tip
        this._templateConfig = null;
        this._defaultConfig = null;
        this._sectionList = [];
        this._hasSuffix = false;
        this._hasPrefix = false;
        this._hasMiddle = false;
        this._destroySubscriptions.forEach(item => item.unsubscribe());
        this._destroySubscriptions = [];
    }

    private _deleteFieldtoLayoutConfig(config, item: SettingConfig) {
        const ctrlName = item.data.name;
        config.forEach(section => {
            section.container.forEach((column, columnIndex) => {
                // tslint:disable-next-line: forin
                for (const index in column) {
                    if (column[index].config.controlID === ctrlName) {
                        column.splice(index, 1);
                        if (column.length === 0) {
                            section.container.splice(columnIndex, 1);
                        }
                        if (section.sectionName === ContactDialogSectionName.BasicInformation) {
                            this.getStatusForBasicInForSection(config);
                            this._resetLayoutForBasicInforSection(config, item);
                        }
                        return;
                    }
                }
            });
        });
    }

    private _getBasicInformationByContainer(sectionContainer: any): any {
        let basicInfoSection;
        if (sectionContainer && sectionContainer.length > 0) {
            for (let i = 0; i < sectionContainer.length; i++) {
                if (sectionContainer[i].sectionName === ContactDialogSectionName.BasicInformation) {
                    basicInfoSection = sectionContainer[i];
                }
            }
        }
        return basicInfoSection;
    }

    /**
     * get Contact Template
     *
     * @private
     * @param {*} res
     * @memberof TemplateSettingDialogComponent
     */
    private _getDefaultContactTemplate(res) {
        this._templateConfig = _lodash.cloneDeep(res);
        this.tplConfig = this._templateConfig.contains;
        this._defaultConfig = _lodash.cloneDeep(DefaultConfigurationContactTemplate);
    }

    /**
     * judge Middle prefix suffix exist
     *
     * @private
     * @param {*} config
     * @param {*} item
     * @memberof TemplateSettingDialogComponent
     */
    private getStatusForBasicInForSection(config) {
        this._hasMiddle = false;
        this._hasPrefix = false;
        this._hasSuffix = false;
        const basicInfoSection = this._getBasicInformationByContainer(config);
        basicInfoSection.container.forEach((column) => {
            for (const item of column) {
                if (item.config.controlID === contactDefField.Suffix) {
                    this._hasSuffix = true;
                }
                if (item.config.controlID === contactDefField.Prefix) {
                    this._hasPrefix = true;
                }
                if (item.config.controlID === contactDefField.MiddleName) {
                    this._hasMiddle = true;
                }
            }
        });
    }

    /**
     * init Template
     *
     * @private
     * @memberof TemplateSettingDialogComponent
     */
    private _initTemplate() {
        // this._templateSettingService.actionSubject$ = new Subject<any>();
        this._sectionList = DefaultConfigurationContactTemplate.sectionList;
        this._destroySubscriptions.push(
            this._store.pipe(
                select(contactTemplateConfigSelector),
            ).subscribe(res => this._getDefaultContactTemplate(res)),
        );
    }

    /**
     * reset Layout for Basicinformation
     *
     * @private
     * @param {*} config
     * @param {SettingConfig} item
     * @memberof TemplateSettingDialogComponent
     */
    private _resetLayoutForBasicInforSection(config, item: SettingConfig) {
        const ctrlName = item.data.name;
        config.forEach(section => {
            section.container.forEach((column, columnIndex) => {
                // tslint:disable-next-line: forin
                for (const index in column) {
                    if (section.secName = 'Basic Information') {
                        if (!this._hasMiddle && !this._hasPrefix && !this._hasSuffix) {
                            if (column[index].config.controlID === ControlId.FirstName) {
                                column[index].css.width = '303';
                            } else if (column[index].config.controlID === ControlId.LastName) {
                                const lastNameJson = _lodash.cloneDeep(column[index]);
                                // delete section.container[columnIndex];
                                column.splice(index, 1);
                                if (!column) {
                                    delete section.container[columnIndex];
                                }
                                lastNameJson.css.width = '303';
                                section.container[0].splice(1, 1, lastNameJson);
                            }
                        } else {
                            if (column[index].config.controlID === ControlId.FirstName
                                && ctrlName === contactDefField.Prefix) {
                                column[index].css.width = '616';
                            } else if (column[index].config.controlID === ControlId.LastName
                                && ctrlName === contactDefField.Suffix) {
                                column[index].css.width = '616';
                            }
                        }
                    }
                }
            });
        });
    }

    /**
     * resize Layout
     *
     * @private
     * @param {*} config
     * @param {SettingConfig} item
     * @memberof TemplateSettingDialogComponent
     */
    private _resizeFieldToLayoutConfig(config, item: SettingConfig) {
        const ctrlName = item.data.name;
        config.forEach(section => {
            section.container.forEach(column => {
                for (const data of column) {
                    if (data.config.controlID === ctrlName) {
                        data.css.width = 616 * item.location;
                    }
                }
            });
        });
    }

    /**
     * suscribe action
     * @private
     * @param {SettingConfig} item
     * @memberof TemplateSettingDialogComponent
     */
    private _settingTemplateConfig(item: SettingConfig) {
        if (item.action === ActionType.ADD ||
            item.action === ActionType.DELETE ||
            item.action === ActionType.CHECKREQUIRED ||
            item.action === ActionType.CHANGE_CONFIG ||
            item.action === ActionType.RESET ||
            item.action === ActionType.MOVE_SECTION) {
            this._isChangeConfig = true;
        }
        switch (item.action) {
            case ActionType.ADD:
                this._addFieldtoLayoutConfig(this.tplConfig, item);
                break;
            case ActionType.DELETE:
                this._deleteFieldtoLayoutConfig(this.tplConfig, item);
                break;
            case ActionType.RESIZE:
                this._resizeFieldToLayoutConfig(this.tplConfig, item);
                break;
            case ActionType.CHECKREQUIRED:
                break;
            default:
                break;
        }
    }

    /**
     * save contact success
     * @private
     * @param {*} res
     * @memberof TemplateSettingDialogComponent
     */
    private _uploadData(res) {
        this._infoToast.message = 'Contact Template updated successfully !';
        this._toast.notify(this._infoToast);
        this.opened = false;
        // need to update the store
        const templateSetting = _lodash.cloneDeep(this._templateConfig);
        this._store.dispatch({
            type: SAVE_CONTACT_TEMPLATE,
            payload: this._contactService.getTemplateConfig(templateSetting)
        });
        // need update success then clear Data.
        this._clearData();
    }
}
